import React, { useState } from "react";
import { PageTitle } from "../../components/common/pageTitle";
import { CustomTabPanel, CustomTabs } from "../../components/common/CustomTabs";
import { AvrJournal } from "./avrJournal";
import styles from "./styles.module.scss";

const tabs = [{ key: "avr", label: "АВР" }];

export const MyDocuments = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div>
      <PageTitle title="Мои документы" />
      <div className={styles.content}>
        <CustomTabs
          value={activeTab}
          tabs={tabs}
          onChange={(e, index) => setActiveTab(index)}
        />
        <CustomTabPanel value={activeTab} index={0}>
          <div className={styles.tabContent}>
            <AvrJournal />
          </div>
        </CustomTabPanel>
      </div>
    </div>
  );
};
